/**
 * 获取列表界面的搜索项
 */
export function getSearchData() {
    return [{
            title: "姓名",
            type: "input",
            value: "",
            key: "name",
        }, {
            title: "入伍年份",
            type: "time-year",
            value: "",
            key: "armyDate",
        },
        {
            title: "职业技能等级",
            type: "select",
            value: "",
            key: "leverl",
            options: []
        },
    ]
}
/**
 * 获取界面搜索框旁边的按钮
 * @param {*} flag  标识哪个界面
 */
export function getTopButArray(flag) {
    let data = []
    switch (flag) {
        case "questionList":
            // 题库列表
            data = [
                { name: "新增用户", active: "create", icon: "el-icon-plus" },
                { name: "通讯录导入", active: "import", icon: "el-icon-upload" },
            ]
            break;

        default:
            break;
    }
    return data
}
/**
 * 获取题库列表表头数据
 */
export function getQuestionTableMenu() {
    return [
        { name: "姓名", key: "name", isStar: false },
        { name: "身份证", key: "identityCard", isStar: false },
        { name: "职业技能等级", key: "leverl", isStar: false },
        { name: "入伍年月", key: "armyDate", isStar: true },
        { name: "出生年月", key: "birthday", isStar: true },
        { name: "学历", key: "education", isStar: false },
        { name: "登录账号", key: "account", isStar: false },
    ]
}

/**
 * 模拟题库列表数据
 */
export function initTableData() {
    return []
}

/**
 * 获取表格操作按钮
 * @param {*} flag  表示当前为哪个界面的
 */
export function getTableBUttonList(flag) {
    switch (flag) {
        case "normal":
            // 正常通讯录按钮
            return [
                { text: "编辑", active: "edit_user" },
                { text: "冻结", active: "freeze_user" },
                { text: "删除", active: "delete_user" },
            ]
            break;
        case "freeze":
            // 已冻结通讯录按钮
            return [
                { text: "解冻", active: "unfreeze_user" },
                { text: "删除", active: "delete_user" },
            ]
            break;

        default:
            break;
    }
}

/**
 * 判断编辑器中是否有填空题选项 
 * @param {*} content  编辑器中返回的数据
 */
export function questionItemReset(content) {
    let spanRegex = new RegExp(
        '<span class="gapfilling-span(.*?)">(.*?)<\\/span>',
        "g"
    );
    let _this = this;
    let newFormItem = [];
    let gapfillingItems = content.match(spanRegex);
    if (gapfillingItems === null) {
        return [];
    }
    gapfillingItems.forEach(function(span, index) {
        let pairRegex = /<span class="gapfilling-span(.*?)">(.*?)<\/span>/;
        pairRegex.test(span);
        newFormItem.push({
            id: null,
            itemUuid: RegExp.$1, // 当前空挡对应的uuid
            title: RegExp.$2, //当前空挡对应的数字
            value: "",
        });
    });

    return newFormItem
}

/**
 * 获取编辑界面数据
 */
export function getEditPersonData(id, options) {
    let data = []
    if (id == "") {
        // 添加时可修改职业技能等级
        data = [
            { title: "姓名", value: "", type: "input", key: "name", ish: true, isNotNull: true },
            { title: "头像", value: "", type: "img", key: "icon", ish: true, isNotNull: false },
            { title: "账号", value: "", type: "input", key: "account", ish: true, isNotNull: true },
            {
                title: "学历",
                value: "",
                type: "select",
                key: "education",
                ish: true,
                options: [
                    { label: "高中或中专以下", value: "高中或中专以下" },
                    { label: "大专", value: "大专" },
                    { label: "本科", value: "本科" },
                    { label: "硕士研究生", value: "硕士研究生" },
                    { label: "博士研究生", value: "博士研究生" },
                ],
                isNotNull: false
            },
            { title: "身份证", value: "", type: "input", key: "identityCard", ish: true, isNotNull: true },
            { title: "出生日期", value: "", type: "time-date", key: "birthday", ish: true, isNotNull: false },
            { title: "入伍日期", value: "", type: "time-date", key: "armyDate", ish: true, isNotNull: true },
            { title: "初次到岗时间", value: "", type: "time-date", key: "firstCome", ish: true, isNotNull: true },
            { title: "初次考核时间限制(月)", value: "3", type: "input", key: "feCon", ish: true, isNotNull: true },
            { title: "职业技能等级", value: "", type: "select", key: "leverl", ish: false, tip: "", isNotNull: false, options: options },
        ]
    } else {
        // 职业技能等级不可进行修改
        data = [
            { title: "姓名", value: "", type: "input", key: "name", ish: true, isNotNull: true },
            { title: "头像", value: "", type: "img", key: "icon", ish: true, isNotNull: false },
            { title: "账号", value: "", type: "input", key: "account", ish: true, isNotNull: true },
            {
                title: "学历",
                value: "",
                type: "select",
                key: "education",
                ish: true,
                options: [
                    { label: "高中或中专以下", value: "高中或中专以下" },
                    { label: "大专", value: "大专" },
                    { label: "本科", value: "本科" },
                    { label: "硕士研究生", value: "硕士研究生" },
                    { label: "博士研究生", value: "博士研究生" },
                ],
                isNotNull: false
            },
            { title: "身份证", value: "", type: "input", key: "identityCard", ish: true, isNotNull: true },
            { title: "出生日期", value: "", type: "time-date", key: "birthday", ish: true, isNotNull: false },
            { title: "入伍日期", value: "", type: "time-date", key: "armyDate", ish: true, isNotNull: true },
            { title: "初次到岗时间", value: "", type: "time-date", key: "firstCome", ish: true, isNotNull: true },
            { title: "初次考核时间限制(月)", value: "3", type: "input", key: "feCon", ish: true, isNotNull: true },
            { title: "职业技能等级", value: "", type: "tip-text", key: "leverl", ish: false, tip: "", isNotNull: false },
        ]
    }
    return data
}